import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Bugsnag from '@bugsnag/js';
import './plugins';

const app = createApp(App);
const bugsnagVue = Bugsnag.getPlugin('vue');

app.use(router);
// @ts-ignore
app.use(bugsnagVue);

app.mount('#app');
